import React from 'react'

import Section from '../Common/Section'
import Typography from '../Common/Typography'
import FeedbackSgnl from './FeedbackSgnl'
import FeedbackSgnx from './FeedbackSgnx'

import { GlobalContext } from '../../context/GlobalContext'
import { useTranslations } from '../../hooks/use-translations'
import { AppRegionEnum } from '../../types/app-region.enum'

import './feedback.styles.scss'

const Feedback: React.FC = () => {
  const { t } = useTranslations()
  const { region } = React.useContext(GlobalContext)

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundColor: '#ecf0f3',
        }}
      >
        <Section className="feedback_container">
          <Typography variant="h2" color="blue" size={40}>
            {t('Feedbacks')}
          </Typography>
          {region === AppRegionEnum.Ru ? <FeedbackSgnl /> : <FeedbackSgnx />}
        </Section>
      </div>
    </>
  )
}

export default Feedback
